// removed by extract-text-webpack-plugin
module.exports = {"panel":"c-MembershipPanel__panel","content":"c-MembershipPanel__content","children":"c-MembershipPanel__children","active":"c-MembershipPanel__active","loading":"c-MembershipPanel__loading"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/MembershipPanel/MembershipPanel.scss
// module id = 875
// module chunks = 0